import type {
  AlertProps,
  SnackbarProps as MuiSnackbarProps,
} from '@mui/material'
import { Alert, Snackbar as MuiSnackbar, Portal } from '@mui/material'
import type { ReactNode } from 'react'

export type SnackbarOptions = {
  anchorOrigin?: MuiSnackbarProps['anchorOrigin']
  autoHideDuration?: MuiSnackbarProps['autoHideDuration']
  severity?: AlertProps['severity']
  variant?: AlertProps['variant']
  icon?: AlertProps['icon']
  /** 閉じるアイコンの代わりに置く操作。閉じる場合は hideSnackbar を呼ぶこと */
  action?: AlertProps['action']
}

type SnackbarMessage = {
  content: ReactNode
  key: string
  options?: SnackbarOptions
}

type SnackbarProps = {
  message: SnackbarMessage | undefined
  onClose: () => void
}

export function Snackbar({ message, onClose }: SnackbarProps) {
  return (
    <Portal>
      <MuiSnackbar
        anchorOrigin={message?.options?.anchorOrigin}
        open={message != undefined}
        key={message?.key}
        onClose={(_, reason) => {
          // スナックバーの外をクリックしても閉じないようにする
          if (reason === 'clickaway') return
          onClose()
        }}
        autoHideDuration={message?.options?.autoHideDuration}
      >
        <Alert
          onClose={onClose}
          severity={message?.options?.severity}
          variant={message?.options?.variant}
          icon={message?.options?.icon}
          action={message?.options?.action}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {message?.content}
        </Alert>
      </MuiSnackbar>
    </Portal>
  )
}
